import React from 'react';
import styled from '@nykaa/ui-components/styles/styled';
import CallOutNudge from '@nykaa/product-card-shared/components/CallOutNudge';
import PriceRevealInfo from './PriceReveal';
import DifferentialPricing from './DifferentialPricing';
import ProTagSvg from './ProTagSvg';
import CardImg from './Img';
import CardTitle from './Title';
import VariantsCount from './VariantsCount';
import CardPrice from './Price';
import RatingInfo from './RatingInfo';
import SaleTagComponent from './SaleTag';
import { defaultTranslationKeys } from './constants';
import { objectEqualiser } from './helper';
import Offer from './Offer';
import TagsWrapper from './Tags/TagsWrapper';
const Wrap = styled.div `
  position: relative;
  height: 100%;
  padding-bottom: 32px;
  overflow: hidden;
  z-index: 0;
`;
const CardInfo = styled.a `
  display: block;
  padding-top: ${({ hasDynamicHeight }) => (hasDynamicHeight ? '0' : '10px')};
  text-decoration: none;
`;
const Stock = styled.span `
  ${({ theme }) => theme.typography.subTitleMedium}
  background-color: #eee;
  color: #000000;
  position: absolute;
  top: 20%;
  left: 25%;
  padding: 4% 8%;
`;
const Details = styled.div `
  margin-top: 4px;
  padding-left: 15px;
  padding-right: 15px;
  white-space: normal;
`;
const SkuLeft = styled.div `
  ${({ theme }) => theme.typography.bodySmall};
  color: #fa6400;
`;
const PrContainer = styled.div `
  margin: ${({ theme: { spacing } }) => `${spacing.spacing20} 15px`};
  margin-top: ${({ theme: { spacing } }) => spacing.spacing40};
`;
const ProductCard = (props) => {
    const { product, showProFlag, imageUrl, pdpPageUrl, lazyLoadImage, size, hasDynamicHeight = false, cardHeight, cardWidth, showReview = true, maxCardHeight, plpPriceReveal, listingPriceReveal, isDifferential, translations: translationsObj = {}, showSkuLeft = true, showCallOutNudge, imageSrcSet, isNewPlpExpEnabled = false, } = props;
    const translations = objectEqualiser(translationsObj, defaultTranslationKeys);
    const { outOfStock, fewLeft, quantityLeft, variant, variants, discount: translatedDiscount, } = translations;
    const { title, offersCount, dynamicTags, inStock, quantity, variantCount, mrp, price, discount, rating, ratingCount, isBackorder, newTags, variantType, offer = '', offerColor = '', showOffer = false, prData, callOutsTemplate, cohortSaleTemplate, brandName, productTitle, type, } = product;
    let tags = dynamicTags;
    const showMultipleTag = Array.isArray(newTags);
    if (showMultipleTag) {
        tags = newTags.map((tag) => tag.title);
    }
    let skuLeft = '';
    if ((quantity > 0) && !isBackorder) {
        if (quantity < 10) {
            const quantityLeftTranslation = `${quantity} ${quantityLeft}`;
            skuLeft = quantityLeftTranslation;
        }
        else if (quantity < 100) {
            skuLeft = fewLeft;
        }
    }
    let customVariant = '';
    if (variantCount && variantType) {
        customVariant = variantCount > 1 ? variants || `${variantType}s` : variant || variantType;
    }
    const showSaleTag = plpPriceReveal && (plpPriceReveal.status);
    const showPRInfo = listingPriceReveal && (listingPriceReveal.isActive) && (prData || cohortSaleTemplate);
    const showFewLeft = (showSkuLeft && (!offer || !showOffer) && skuLeft);
    return (React.createElement(Wrap, null,
        (showProFlag) && (React.createElement(ProTagSvg, null)),
        showSaleTag && React.createElement(SaleTagComponent, { plpPriceReveal: plpPriceReveal }),
        (!showSaleTag) && (React.createElement(TagsWrapper, { showMultipleTag: showMultipleTag, tags: tags, newTags: newTags, newTagsStyle: newTags, offersCount: offersCount })),
        React.createElement(CardInfo, { hasDynamicHeight: hasDynamicHeight, href: pdpPageUrl },
            React.createElement(CardImg, { src: imageUrl, alt: title, srcSet: imageSrcSet, inStock: inStock, isLazy: lazyLoadImage, hasDynamicHeight: hasDynamicHeight, cardHeight: cardHeight, cardWidth: cardWidth, maxCardHeight: maxCardHeight }),
            (!inStock) && (React.createElement(Stock, null, outOfStock)),
            React.createElement(Details, null,
                showCallOutNudge && React.createElement(CallOutNudge, { callOutsTemplate: callOutsTemplate }),
                React.createElement(CardTitle, { title: title, brandName: brandName, isNewPlpExpEnabled: isNewPlpExpEnabled, productTitle: productTitle, variantType: type }),
                React.createElement(VariantsCount, { variantType: customVariant, variantCount: variantCount, isTranslated: Boolean(customVariant) }),
                (!hasDynamicHeight || showReview) && (React.createElement(RatingInfo, { rating: rating, ratingCount: ratingCount })),
                React.createElement(CardPrice, { mrp: mrp, price: price, discount: discount, size: size, discountTranslation: translatedDiscount }),
                showOffer && (React.createElement(Offer, { message: offer, color: offerColor })),
                showFewLeft && (React.createElement(SkuLeft, null, skuLeft))),
            showPRInfo && (React.createElement(PrContainer, null, isDifferential ? (React.createElement(DifferentialPricing, { prData: cohortSaleTemplate, listingPriceReveal: listingPriceReveal, isDifferential: true })) : (React.createElement(PriceRevealInfo, { prData: prData, listingPriceReveal: listingPriceReveal })))))));
};
export default ProductCard;
